<template>
  <div class="dialog">
    <div class="dialog__body">
      <div :key="idx" v-for="(dialogItem, idx) in dialog">
        <div class="dialog__item">
          <div class="dialog__item-logo">
            <img :src="dialogItem.sender.avatar" alt="">
          </div>
          <div class="dialog__item-top">
            <div class="dialog__item-top-user">
              <div>
                <div class="dialog__item-fullname">{{ dialogItem.sender.name ? dialogItem.sender.name : 'DELETED' }} {{ dialogItem.sender.surname ? dialogItem.sender.surname : '' }}</div>
              </div>
              <div>
                <div class="dialog__item-date">
                  {{ dateFunc(dialogItem.created_at) }}
                </div>
              </div>
            </div>
            <div class="dialog__item-body">
              <p>{{ dialogItem.body }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dialog',
  props: {
    dialog: Array
  },
  computed: {
    isMobile() {
      return document.documentElement.clientWidth < 991
    }
  },
  methods: {
    dateFunc(date){
      let duration = this.$moment.duration(this.$moment().diff(date));
      if(duration.asHours() > 4){
        return this.$moment(date).calendar()
      }else{
        return this.$moment(date).fromNow()
      }
    }
  }
}
</script>
<style scoped lang="scss">
.dialog {
  padding: 0 10px;
  display: flex;
  width: 100%;
  max-height: 600px;
  overflow-y: auto;
  background-color: #fff;

  &__body{
    width: 100%;
  }
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: rgba(0,0,0,0.05);
  }
  &::-webkit-scrollbar-thumb {
    background-color: #b0b0b0;
    border-radius: 20px;
  }
}

.dialog__item {
  padding: 10px 0;
  display: flex;

  &-top {
    &-user {
      display: flex;
      align-items: center;
    }
  }

  &-fullname {
    font-weight: 600;
    font-size: 16px;
    color: #B9765B;
    margin-right: 10px;
  }

  &-date {
    line-height: 24px;
    font-size: 14px;
    color: #808080;
  }

  &-day {
    display: flex;
    justify-content: center;
    line-height: 24px;
    font-size: 14px;
    color: #808080;
  }

  &-logo, img {
    border: 1px solid #DBBFA7;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
  }

  img {
    margin-right: 0;
  }

  &-body {
    font-size: 14px;
    line-height: 1.71;
    color: #383838;

    p {
      width: 90%;
    }
  }
}

@media screen and (max-width: 991px) {
  .dialog__item-logo,
  .dialog__item img {
    width: 35px;
    height: 35px;
  }
  .dialog__item-fullname {
    display: none;
  }
  .dialog__item-date {
    //position: absolute;
    //right: 0;
  }
  .dialog__item {
    position: relative;
  }
  .dialog__item-body {
    max-width: 75%;
  }
}
</style>
